import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InnerImageZoom from 'react-inner-image-zoom';
import styled, { css } from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const ZoomIcon = styled(Icon)`
    position:absolute;
    top: 8px;
    right: 5px;
    float: right;
    stroke: none;
    svg path:last-child {
          fill: ${({ theme }) => theme.colors.neutral.grey[4]};
    }
`;


const ImageWrapper = styled.div`
  touch-action: pan-y;
  ${(props) => ((props.inTouch || props.isZoomed) && css`
    touch-action: none;
  `)};
`;

const ZoomableImage = ({ src, alt }) => {
  
  const [isZoomed, setIsZoomed] = useState(false);
  const [inTouch, setInTouch] = useState(false);
  
  return (
    <ImageWrapper
      isZoomed={isZoomed}
      inTouch={inTouch}
      onTouchStart={() => {
        setInTouch(true);
      }}
      onTouchEnd={() => {
        setInTouch(false);
      }}
    >
      <InnerImageZoom
        src={src}
        alt={alt}
        zoomScale={2}
        className={'iiz-product-image'}
        hideCloseButton
        afterZoomIn={() => {
          setIsZoomed(true);
        }}
        afterZoomOut={() => {
          setIsZoomed(false);
        }}
      />
      <ZoomIcon icon={'zoom'} size={'large'} visible={!isZoomed} rotate={90} />
    </ImageWrapper>
  );
};

ZoomableImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};


export default ZoomableImage;
